import { render } from "./UpdateRelativesEmailComponent.vue?vue&type=template&id=64fd6b00&scoped=true"
import script from "./UpdateRelativesEmailComponent.vue?vue&type=script&lang=js"
export * from "./UpdateRelativesEmailComponent.vue?vue&type=script&lang=js"

import "./UpdateRelativesEmailComponent.vue?vue&type=style&index=0&id=64fd6b00&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fd6b00"]])

export default __exports__